var _Check;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { chipClasses } from '@mui/material/Chip';
import { bool, func, number, object, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { Check } from 'mosaic-react-icons';
import Chip from '../internals/components/chip/Chip';
const StyledChip = styled(Chip)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    '&.Mui-selected': {
      ["& .".concat(chipClasses.label)]: {
        paddingInlineStart: spacing(1)
      },
      ["& .".concat(chipClasses.icon)]: {
        margin: 0,
        paddingInlineStart: spacing(1),
        width: spacing(3)
      }
    }
  };
});

/**
 * Used to toggle a choice off or on, similar to a checkbox
 */
const SovosChipFilter = _ref2 => {
  let {
    classes,
    className,
    selected,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledChip, _extends({
    classes: classes,
    className: clsx('sovosChipFilter', className, {
      'Mui-selected': selected
    }),
    icon: selected === true ? _Check || (_Check = /*#__PURE__*/React.createElement(Check, {
      "data-testid": "check"
    })) : null,
    selected: selected
  }, rest));
};
SovosChipFilter.propTypes = {
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Content of the chip
   */
  label: string.isRequired,
  /**
   * Maximum width of the chip
   */
  maxWidth: number,
  /**
   * Callback fired when the chip is clicked. For `input` chips, this is
   * attached to the delete icon.
   */
  onClick: func,
  /**
   * If `true`, the chip is selected. This will change the background color
   * for `choice` and `filter` chips
   */
  selected: bool
};
SovosChipFilter.baseComponent = {
  name: 'Chip',
  link: 'chip/'
};
export default SovosChipFilter;